import { fetchJson } from 'utils/fetch';

export const getAdvUnreadCount = () => fetchJson('/messaging/unread.json');



// WEBPACK FOOTER //
// ./src/modules/messaging/api/index.js